import { render, staticRenderFns } from "./luckyNangkwak.vue?vue&type=template&id=e73c059c&scoped=true"
import script from "./luckyNangkwak.vue?vue&type=script&lang=js"
export * from "./luckyNangkwak.vue?vue&type=script&lang=js"
import style0 from "./luckyNangkwak.vue?vue&type=style&index=0&id=e73c059c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73c059c",
  null
  
)

export default component.exports